// Helpers UX pour la fiche commerciale et le dashboard
export function missingFields(o) {
  const missing = [];
  if (!o.contact_nom) missing.push("contact");
  if (!o.contact_telephone) missing.push("téléphone");
  if (!o.besoin) missing.push("besoin");
  if (!o.montant_estime) missing.push("montant estimé");
  if (!o.prochaine_action) missing.push("prochaine action");
  return missing;
}

// Mapping 10 étapes backend → 5 catégories simplifiées pour téléprospectrices
export const SIMPLE_BUCKETS = [
  { id: "a_traiter", label: "À traiter", color: "bg-brand-paper text-brand-ink border-brand-line",
    match: (o) => o.stage === "interesse" && !o.prochaine_action },
  { id: "interesse", label: "Intéressé", color: "bg-brand-moss/10 text-brand-moss border-brand-moss/25",
    match: (o) => o.stage === "interesse" && !!o.prochaine_action },
  { id: "rdv_obtenu", label: "Rendez-vous obtenu", color: "bg-brand-moss/15 text-brand-moss border-brand-moss/30",
    match: (o) => ["rdv_programme", "rdv_confirme", "rdv_realise"].includes(o.stage) },
  { id: "a_relancer", label: "À relancer", color: "bg-[#FAF8F1] text-[#6B5B33] border-[#E9E2CF]",
    match: (o) => ["proposition_a_preparer", "proposition_envoyee"].includes(o.stage) },
  { id: "transfere", label: "Transféré au commercial", color: "bg-brand-ink text-white border-brand-ink",
    match: (o) => ["negociation", "signe"].includes(o.stage) },
];

export function bucketFor(opp) {
  return SIMPLE_BUCKETS.find((b) => b.match(opp));
}
